/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Tag score with confidence tracking */
export type TagScore = {
  /** Tag name (e.g., "fast-responder", "defi-expert") */
  tagName: string;
  /** Confidence score in basis points (0-10000) */
  confidence: number;
  /** Number of supporting data points for this tag */
  evidenceCount: number;
  /** Last time this tag was updated */
  lastUpdated: bigint;
};

export type TagScoreArgs = {
  /** Tag name (e.g., "fast-responder", "defi-expert") */
  tagName: string;
  /** Confidence score in basis points (0-10000) */
  confidence: number;
  /** Number of supporting data points for this tag */
  evidenceCount: number;
  /** Last time this tag was updated */
  lastUpdated: number | bigint;
};

export function getTagScoreEncoder(): Encoder<TagScoreArgs> {
  return getStructEncoder([
    ["tagName", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["confidence", getU16Encoder()],
    ["evidenceCount", getU32Encoder()],
    ["lastUpdated", getI64Encoder()],
  ]);
}

export function getTagScoreDecoder(): Decoder<TagScore> {
  return getStructDecoder([
    ["tagName", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["confidence", getU16Decoder()],
    ["evidenceCount", getU32Decoder()],
    ["lastUpdated", getI64Decoder()],
  ]);
}

export function getTagScoreCodec(): Codec<TagScoreArgs, TagScore> {
  return combineCodec(getTagScoreEncoder(), getTagScoreDecoder());
}
